var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgLogoFacebook = function SvgLogoFacebook(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 9.9 21.4"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.5 10.7h-3v10.7H2.1V10.7H0V6.9h2.1V4.5A4.2 4.2 0 0 1 6.6 0h3.3v3.7H7.5a.9.9 0 0 0-1 1v2.2H10Z"
  })));
};
export default SvgLogoFacebook;